import { useState } from "react";

const LINE_H = 18; // px，单行行高估算
const COLLAPSED_LINES = 3;
const EXPANDED_LINES = 15;

/**
 * CC 终端输出块（system.local_command_output）
 * 默认显示 3 行；点击折叠按钮收起为 1 行；展开后显示 15 行并支持滚动。
 */
const CCTerminalBlock = ({ command, content }) => {
  // expanded: false=折叠(1行), null=默认(3行), true=展开(15行)
  const [state, setState] = useState("default");

  const getMaxHeight = () => {
    if (state === "collapsed") return `${LINE_H}px`;
    if (state === "expanded") return `${LINE_H * EXPANDED_LINES}px`;
    return `${LINE_H * COLLAPSED_LINES}px`;
  };

  const toggleLabel = () => {
    if (state === "collapsed") return "▶";
    if (state === "expanded") return "▲";
    return "▼";
  };

  const toggleTitle = () => {
    if (state === "collapsed") return "展开";
    if (state === "expanded") return "折叠";
    return "展开";
  };

  const handleToggle = () => {
    if (state === "collapsed") setState("default");
    else if (state === "default") setState("expanded");
    else setState("collapsed");
  };

  return (
    <div style={{
      background: "#0d1117",
      border: "1px solid #30363d",
      borderRadius: "6px",
      margin: "6px 0",
      overflow: "hidden",
      fontFamily: "'Courier New', Consolas, monospace",
      fontSize: "12px",
    }}>
      {/* 标题栏 */}
      <div style={{
        background: "#161b22",
        padding: "4px 8px 4px 12px",
        color: "#7ee787",
        borderBottom: "1px solid #30363d",
        display: "flex",
        alignItems: "center",
        gap: "6px",
      }}>
        <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {command ? `$ ${command}` : "输出"}
        </span>
        <button
          onClick={handleToggle}
          title={toggleTitle()}
          style={{
            background: "none",
            border: "none",
            color: "#8b949e",
            cursor: "pointer",
            fontSize: "10px",
            padding: "0 4px",
            flexShrink: 0,
            lineHeight: 1,
          }}
        >
          {toggleLabel()}
        </button>
      </div>

      {/* 内容区 */}
      <pre className="ybg-thin-scroll" style={{
        margin: 0,
        padding: "6px 12px",
        color: "#e6edf3",
        whiteSpace: "pre-wrap",
        wordBreak: "break-all",
        maxHeight: getMaxHeight(),
        overflowY: state === "expanded" ? "auto" : "hidden",
        transition: "max-height 0.15s ease",
        scrollbarWidth: "thin",
        scrollbarColor: "#30363d transparent",
      }}>
        {content}
      </pre>
    </div>
  );
};

export default CCTerminalBlock;
